import React, { useState, useEffect, useCallback, useRef } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../context/LoadingContext";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import dayjs from "dayjs";

import EditIcon from "@mui/icons-material/Edit";
import {
  fetchData,
  searchfetchQueries,
} from "../../Requirement/services/RequirementServices";
import AlertModal from "../../Requirement/components/common/AlerModel";
import RFQForm from "./components/RFQForm";
import MatchingOffers from "./components/MatchingOffers";

import * as bootstrap from "bootstrap";
import {
  Tooltip,
  IconButton,
  FormControlLabel,
} from "@mui/material";

import CustomIOSSwitch from "../../../services/iosSwitch";
const RFQs = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [activeUser, setActiveUser] = useState("");
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [mode, setMode] = useState("Open");
  const [rfqList, setRfqList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [searchValues, setSearchValues] = useState({
    requirementNumber: "",
    searchProduct: "",
    searchProductGrade: "",
    searchQuantityRange: "",
  });
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [formMode, setFormMode] = useState(null); // "add", "edit", or "view"
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [matchingOffers, setMatchingOffers] = useState(false);
  const [matchingOffersRequirement, setMatchingOffersRequirement] =
    useState(null);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [rfqHistory, setRfqHistory] = useState([]);
  const modalRef = useRef(null); // Reference to the modal DOM element

  const quantityOptions = [
    { value: "", label: "Select Range" },
    { value: "50-100", label: "50-100 MT" },
    { value: "100-200", label: "100-200 MT" },
    { value: "200-500", label: "200-500 MT" },
    { value: "Above-500", label: "Above 500 MT" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const handleModeChange = (newMode) => {
    setMode(newMode);
    setMatchingOffers(false); // Hide MatchingOffers when mode changes
  };

  // Callback function to receive value from child
  const handleChildResponse = () => {
    console.log("parent handleChildResponse");
    setRowStart(0);
    searchRFQs(searchValues, 0);
    setMatchingOffers(false);
    setMatchingOffersRequirement(null);
  };

  const getBuyerInfo = useCallback(async (buyerEmail) => {
    try {
      const response = await fetchData({
        target: "listAMTPLUsers",
        userOrder: "AMTPLUserID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { EmailID: buyerEmail },
      });
      setBuyerInfo(response.items || []);
    } catch (error) {
      console.error("Error loading buyer info:", error);
      setBuyerInfo([]);
    }
  }, []);

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [allProducts] = await Promise.all([
        searchfetchQueries({
          target: "listAllProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      setAllProductMaster(allProducts);
      const distinctProducts = Array.from(
        new Map(
          allProducts
            .filter((p) => p.productStatus === "ACTIVE") // ✅ Only include active products
            .map((p) => [p.ProductName, p])
        ).values()
      );
      setProductList(distinctProducts);
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
      setProductList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  const searchRFQs = useCallback(
    async (searchValue, newRowStart = rowStart) => {
      setLoading(true);
      try {
        let quantityFilter = {};
        if (searchValue.searchQuantityRange) {
          if (searchValue.searchQuantityRange === "Above-500") {
            quantityFilter = { QuantityGTE: 500 };
          } else {
            const [min, max] = searchValue.searchQuantityRange
              .split("-")
              .map((val) => parseFloat(val));
            quantityFilter = { QuantityGTE: min, QuantityLTE: max };
          }
        }

        const today = new Date().toISOString().split("T")[0];
        let productId = "";
        if (searchValue.searchProduct && searchValue.searchProductGrade) {
          const product = allProductMaster.find(
            (p) =>
              p.ProductName === searchValue.searchProduct &&
              p.Grade === searchValue.searchProductGrade
          );
          if (product) {
            productId = product.ProductID;
            console.log("product##", product.ProductID);
          } else {
            console.warn(
              `No product found for ProductName: ${searchValue.searchProduct}, Grade: ${searchValue.searchProductGrade}`
            );
          }
        }

        const body = {
          target: "listRequirements",
          userOrder: "CreateDate DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            CategoryType: "rfq", // Changed to show RFQ specific data
            ...(mode === "Close"
              ? { ValidUntilLT: "'" + today + "'" }
              : { ValidUntilGTE: "'" + today + "'" }),
            BuyerEmailID: activeUser,
            ...(searchValue.requirementNumber && {
              RequirementNumber: searchValue.requirementNumber,
            }),
            ProductID: productId,
            ...quantityFilter,
          },
        };
        const response = await fetchData(body);

        const modifiedItems = (response.items || response).map((item) => ({
          ...item,
          id: item.RequirementsID, // Add id property with value from RequirementsID
        }));

        setRfqList(modifiedItems);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading RFQs: ", error);
        setRfqList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, activeUser, mode, allProductMaster]
  );

  const handleSearch = (searchValues) => {
    setRowStart(0);
    searchRFQs(searchValues, 0);
    setMatchingOffers(false); // Hide MatchingOffers when searching
  };

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    searchRFQs(searchValues, newRowStart);
  };

  const handleAdd = () => {
    setIsFormVisible((prev) => !prev);
    setFormMode("add");
    setSelectedRFQ(null);
    setMatchingOffers(false); // Hide MatchingOffers when adding
  };

  const handleActionClick = (event, row, mode) => {
    event.stopPropagation(); // Prevent row click from triggering
    console.log(`handleActionClick: row=${JSON.stringify(row)}, mode=${mode}`); // Debug log
    setSelectedRFQ(row);
    setFormMode(mode); // "view" or "edit"
    setIsFormVisible(true);
    setMatchingOffers(false); // Hide MatchingOffers
    setHistoryVisible(false);
  };

  const handleRowClick = (row, event) => {
    // Only trigger if not clicking on action buttons
    console.log("row@@", row);
    setMatchingOffers(true);
    setSelectedRFQ(row);
    setFormMode("view");
    setMatchingOffersRequirement(row);
    setIsFormVisible(true);
    setHistoryVisible(false);
  };
  const handleHistoryClick = async () => {
    if (!selectedRFQ || !selectedRFQ.RequirementsID) {
      console.warn("No RFQ selected");
      return;
    }

    setHistoryVisible(true);
    setLoading(true);

    try {
      // Fetch history from ModuleLog service
      const body = {
        target: "listModuleLog",
        filterTerms: {
          Module: "RFQ",
          Id: selectedRFQ.RequirementsID,
        },
        userOrder: "CreatedAt DESC",
        rowStart: 0,
        pageSize: 50,
      };
      const historyData = await fetchData(body);

      if (historyData && historyData.items) {
        // Transform the data to match the timeline format
        const transformedHistory = historyData.items.map((item, index) => ({
          id: index + 1,
          title: item.Info || "N/A",
          company: item.SubInfo || "",
          datetime: item.CreatedAt
            ? dayjs(item.CreatedAt).format("DD MMM YYYY")
            : "",
          status: "completed",
        }));
        setRfqHistory(transformedHistory);
      } else {
        setRfqHistory([]);
      }
    } catch (error) {
      console.error("Error fetching RFQ history:", error);
      setRfqHistory([]);
    } finally {
      setLoading(false);
    }

    if (modalRef.current) {
      const bsModal = new bootstrap.Modal(modalRef.current, {
        backdrop: true,
        keyboard: true,
      });
      bsModal.show();
    }
  };

  const cancelHistory = () => {
    setHistoryVisible(false);
    if (modalRef.current) {
      const bsModal = bootstrap.Modal.getInstance(modalRef.current);
      if (bsModal) {
        bsModal.hide();
      }
    }
  };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "requirementNumber",
      label: "RFQ Number",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, requirementNumber: value })),
      value: searchValues.requirementNumber,
    },
    {
      name: "searchProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProduct: value }));
        loadProductGrades(value);
      },
    },
    {
      name: "searchProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProductGrade: value }));
      },
    },
    {
      name: "searchQuantityRange",
      label: "Quantity Range (MT)",
      type: "dropdown",
      options: quantityOptions,
      value: searchValues.searchQuantityRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchQuantityRange: value }));
        searchRFQs({ ...searchValues, searchQuantityRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "RequirementNumber", numeric: false, label: "RFQ No." },
    {
      id: "Product",
      numeric: false,
      label: "Product",
      renderCell: (row) => {
        const pn = allProductMaster.find(
          (item) => item.ProductID === row.ProductID
        );
        return pn ? pn.ProductName : "";
      },
    },
    {
      id: "Grade",
      numeric: false,
      label: "Grade",
      renderCell: (row) => {
        const pn = allProductMaster.find(
          (item) => item.ProductID === row.ProductID
        );
        return pn ? pn.Grade : "";
      },
    },
    { id: "Quantity", numeric: false, label: "Quantity(MT)" },
    { id: "OriginCountry", numeric: false, label: "Origin" },
    {
      id: "DeliveryLocation",
      numeric: false,
      label: "Destination",
      renderCell: (row) => {
        let res = row.DeliveryLocation.split("~");
        if (Array.isArray(res)) {
          return res[0];
        }
        return "";
      },
    },
    {
      id: "ShipmentPeriod",
      numeric: false,
      label: "Shipment Period",
      renderCell: (row) => {
        let dpFrom = row.DeliveryPeriodFrom
          ? dayjs(row.DeliveryPeriodFrom).format("DD-MM-YYYY")
          : "";
        let dpTill = row.DeliveryPeriodTill
          ? dayjs(row.DeliveryPeriodTill).format("DD-MM-YYYY")
          : "";
        return dpFrom !== "" && dpTill !== "" ? dpFrom + " to " + dpTill : "";
      },
    },
    {
      id: "DeliveryPort",
      numeric: false,
      label: "Delivery Port",
      renderCell: (row) => {
        let res = row.DeliveryLocation.split("~");
        if (Array.isArray(res) && res.length > 0) {
          return res[1];
        }
        return "";
      },
    },
    { id: "Incoterm", numeric: false, label: "Incoterms" },
    {
      id: "ProductPackaging",
      numeric: false,
      label: "Packaging",
      renderCell: (row) => {
        const jsonLike = row.ProductPackaging.replace(/{|}/g, "")
          .split(",")
          .map((part) => part.split("="))
          .reduce((obj, [key, value]) => {
            obj[key.trim()] = value ? value.trim() : "";
            return obj;
          }, {});
        return jsonLike.item;
      },
    },
    {
      id: "RequirementDate",
      numeric: false,
      label: "Created",
      renderCell: (row) =>
        row.RequirementDate
          ? dayjs(row.RequirementDate).format("DD-MM-YYYY")
          : "",
    },
    {
      id: "ValidUntil",
      numeric: false,
      label: "Expires",
      renderCell: (row) =>
        row.ValidUntil ? dayjs(row.ValidUntil).format("DD-MM-YYYY") : "",
    },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => {
        let bgColor = "",
          textColor = "";
        switch (row.Status) {
          case "Draft":
            bgColor = "#fef3c7";
            textColor = "#b45309";
            break;
          case "Resolved":
            bgColor = "#d1fae5";
            textColor = "#855a0bff";
            break;
          case "In Review":
            bgColor = "#ceded1ff";
            textColor = "#129e25ff";
            break;
          default:
            bgColor = "#f3f4f6";
            textColor = "#374151";
        }
        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "3px 6px",
              borderRadius: "25px",
              fontSize: "0.75rem",
              fontWeight: 500,
              width: "120px",
            }}
          >
            {row.Status === "In Review" ? "Submitted" : row.Status}
          </span>
        );
      },
    },
    {
      id: "action",
      numeric: false,
      label: "Action",
      renderCell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "2px",
            alignItems: "center",
            margin: 0,
            padding: 0,
          }}
        >
          <Tooltip title="Edit RFQ">
            <IconButton
              onClick={(e) => handleActionClick(e, row, "edit")}
              sx={{ color: "#de6b14", width: "15px", height: "15px" }}
            >
              <EditIcon sx={{ width: "15px", height: "15px" }} />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut();
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email);
          getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/buyer");
      }
    };
    checkUser();
    loadAllProducts();
  }, [navigate, loadAllProducts, getBuyerInfo]);

  useEffect(() => {
    if (activeUser && allProductMaster.length > 0) {
      searchRFQs(searchValues);
    }
  }, [
    rowStart,
    pageSize,
    activeUser,
    mode,
    searchRFQs,
    searchValues,
    allProductMaster,
  ]);

  // Pass the matchingOffersRequirement ID to DataTable via selectedRows
  const selectedRows = matchingOffersRequirement
    ? [matchingOffersRequirement.RequirementsID || matchingOffersRequirement.id]
    : [];
  
  return (
    <div>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="table-header-re">
        {/* <div className="header-text">
          <div className="head-text">My RFQs</div>
        </div> */}
        <div className="head-btn">
          {mode}
          <FormControlLabel
            control={
            <CustomIOSSwitch 
            checked={mode === "Open"} 
            onChange={(e) =>
                  handleModeChange(e.target.checked ? "Open" : "Close")
                }
                name="mode"
                sx={{ m: 1 }} />
              }
           
          />
          {/* <FormControlLabel
            control={
              <IOSSwitch
                checked={mode === "Open"}
                onChange={(e) =>
                  handleModeChange(e.target.checked ? "Open" : "Close")
                }
                name="mode"
                sx={{ m: 1 }}
              />
            }
            label=""
            sx={{ marginRight: 1 }}
          /> */}
          <button className="submit-btn" onClick={handleAdd}>
            {isFormVisible ? "Cancel" : "Add"}
          </button>
        </div>
      </div>
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">My RFQs</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={rfqList}
        total={totalItems}
        title="RFQ Information"
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        onRowClick={handleRowClick}
        selectedRows={selectedRows}
      />
      {isFormVisible && (
        <RFQForm
          formMode={formMode}
          setFormMode={setFormMode}
          selectedRFQ={selectedRFQ}
          setIsFormVisible={setIsFormVisible}
          // productList={productList}
          allProductMaster={allProductMaster}
          activeUser={activeUser}
          buyerInfo={buyerInfo}
          totalItems={totalItems}
          setModal={setModal}
          searchRFQs={searchRFQs}
          searchValues={searchValues}
          navigate={navigate}
          onHistoryClick={handleHistoryClick}
          btnCancel={formMode === "view" ? false : true}
          btnAddFinanceRfq={true}
          btnHistory={true}
        />
      )}
      {matchingOffers && matchingOffersRequirement && (
        <MatchingOffers
          requirementDetails={matchingOffersRequirement}
          activeUser={activeUser}
          onResponse={handleChildResponse}
        />
      )}
      <div
        className="modal modal-right fade"
        id="historyModal"
        tabIndex="-1"
        aria-labelledby="historyModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content ">
            <div className="modal-header">
              <h5 className="modal-title" id="historyModalLabel">
                RFQ History
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={cancelHistory}
              ></button>
            </div>
            <div className="modal-body">
              <ul className="timeline list-unstyled position-relative ps-4">
                {rfqHistory.length > 0 ? (
                  rfqHistory.map((item) => (
                    <li key={item.id} className="mb-4 position-relative">
                      <span
                        className="timeline-icon rounded-circle d-inline-block position-absolute"
                        style={{
                          width: "14px",
                          height: "14px",
                          left: "-28px",
                          top: "5px",
                          backgroundColor: "rgb(222 107 20)",
                        }}
                      ></span>
                      <div>
                        <strong>{item.title}</strong>
                        {item.company && (
                          <div className="text-muted small">{item.company}</div>
                        )}
                        <div className="text-muted small">{item.datetime}</div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="mb-4 position-relative">
                    <div>
                      <strong>No history available</strong>
                      <div className="text-muted small">
                        No history entries found for this RFQ
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={cancelHistory}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RFQs;
